import React from 'react'
import { NotificationAccess } from '../../../_metronic/layout/components/account'

export const NotificationsAccessPage = () => {
  return (
    <NotificationAccess/>
  )
}
